import { ScgpExportOrderStatusSap } from "@saleor/graphql";

export enum FIELD_TYPE {
  SINGLE_INPUT = "SINGLE_INPUT",
  SINGLE_SELECT = "SINGLE_SELECT",
  SUGGESTION_INPUT = "SUGGESTION_INPUT",
  MULTIPLE_SUGGESTION_INPUT = "MULTIPLE_SUGGESTION_INPUT",
  RADIO_GROUP = "RADIO_GROUP",
  DATEPICKER = "DATEPICKER",
  MULTIPLE_SELECT = "MULTIPLE_SELECT"
}

export const orderTypeChoices = [
  { label: "All", value: "ALL" },
  { label: "Complete", value: ScgpExportOrderStatusSap.COMPLETE },
  { label: "Being Process", value: ScgpExportOrderStatusSap.BEING_PROCESS }
];

export interface SubmitFilterDataType {
  saleOrg?: string;
  channel?: string;
  orderType?: string;
  saleGroup?: string;
  bu?: string;
  company?: string;
  statusSAP?: string;
  saleEmployee?: string;
  invoiceNo?: string;
  dpNo?: string;
  dateSelectionType?: DateSelectionType;
  soldTo?: string;
  createDate?: {
    gte: string;
    lte: string;
  };
  requestDeliveryDate?: {
    gte: string;
    lte: string;
  };
  saleOrderNo?: string;
  purchaseOrderNo?: string;
  salesEmployeeNo?: string;
  materialNoMaterialDescription?: string[];
  materialGradeGram?: string;
  materialPricingGroup?: string;
  plant?: string;
  materialGroup1?: string[];
  deliveryBlock?: string;
  createBy?: string;
  status?: string;
  requireAttentionFlag?: string;
  sourceOfApp?: string;
}

export enum DateSelectionType {
  CREATE_DATE = "CREATE_DATE",
  LAST_UPDATE = "LAST_UPDATE"
}

export enum StatusSelectionType {
  ALL = "ALL",
  PENDING = "PENDING",
  COMPLETE = "COMPLETE"
}
